import {
  ApiKeysActionTypes,
  ApiKeysState,
  ApiKeysAction,
} from './apiKeys.types';

const initialState: ApiKeysState = {
  // Data
  apiKey: null,
  generatedKey: null,

  // Loading states
  loading: false,
  generateLoading: false,
  fetchLoading: false,

  // Error states
  error: null,
  generateError: null,
  fetchError: null,

  // Success states
  success: null,
  generateSuccess: false,
  fetchSuccess: false,
};

const apiKeysReducer = (
  state: ApiKeysState = initialState,
  action: ApiKeysAction
): ApiKeysState => {
  switch (action.type) {
    // Generate API Key
    case ApiKeysActionTypes.GENERATE_API_KEY_REQUEST:
      return {
        ...state,
        generateLoading: true,
        generateError: null,
        generateSuccess: false,
      };

    case ApiKeysActionTypes.GENERATE_API_KEY_SUCCESS:
      return {
        ...state,
        generateLoading: false,
        generateSuccess: true,
        generatedKey: action.payload,
        success: 'API key generated successfully',
      };

    case ApiKeysActionTypes.GENERATE_API_KEY_FAILURE:
      return {
        ...state,
        generateLoading: false,
        generateError: action.payload,
        generateSuccess: false,
        error: action.payload,
      };

    // Get API Key
    case ApiKeysActionTypes.GET_API_KEY_REQUEST:
      return {
        ...state,
        fetchLoading: true,
        fetchError: null,
        fetchSuccess: false,
      };

    case ApiKeysActionTypes.GET_API_KEY_SUCCESS:
      return {
        ...state,
        fetchLoading: false,
        fetchSuccess: true,
        apiKey: action.payload,
        error: null,
      };

    case ApiKeysActionTypes.GET_API_KEY_FAILURE:
      return {
        ...state,
        fetchLoading: false,
        fetchError: action.payload,
        fetchSuccess: false,
        error: action.payload,
      };

    // Clear Actions
    case ApiKeysActionTypes.CLEAR_API_KEYS_STATE:
      return {
        ...state,
        error: null,
        generateError: null,
        fetchError: null,
        success: null,
        generateSuccess: false,
        fetchSuccess: false,
      };

    default:
      return state;
  }
};

export default apiKeysReducer;
